export default __webpack_public_path__ + "static/media/atharva.6e6ab316.jpeg";